<div class="container">
  <div
    class="controls"
    *ngIf="showControls"
  >
    <div class="upper-controls">
      <app-visionboard-customer-item-request-button
        class="request-button"
        *ngIf="showRequestButton"
        source="Request Item - VB Freeform Main Button"
        [venueId]="eventVenueId"
        [venueOptional]="true"
      ></app-visionboard-customer-item-request-button>
      <app-visionboard-workspace-vendor-filter-button></app-visionboard-workspace-vendor-filter-button>
    </div>
    <app-visionboard-global-search-button source="Freeform"></app-visionboard-global-search-button>
  </div>
  <mat-accordion
    id="visionboard-categories-accordion-tutorial-target"
    class="visionboard-categories"
    displayMode="flat"
  >
    <mat-expansion-panel
      class="visionboard-category mat-elevation-z0"
      *ngFor="let category of categories"
      (closed)="onCategoryPanelClosed()"
    >
      <mat-expansion-panel-header
        [collapsedHeight]="headerHeight"
        [expandedHeight]="headerHeight"
      >
        <mat-panel-title class="category-title">
          {{ category.name }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <button
        mat-menu-item
        class="sub-category-button"
        (click)="onSubCategoryClick(category, subCategory)"
        [ngClass]="getButtonClasses(category, subCategory)"
        *ngFor="let subCategory of category.subCategories"
        id="{{ getSubCategoryKey(category, subCategory) }}"
      >
        {{ subCategory.name }}
      </button>
    </mat-expansion-panel>
  </mat-accordion>
</div>
